<template>
  <div>
    <input-base
        ref="base"
        :validated-field="validatedField"
        :field-config="fieldConfig"
    >
      <template v-slot:editor>
        <b-input
            v-model="validatedField.value"
            :disabled="readOnly"
        >
        </b-input>
        <div
            v-if="hexColor"
            class="ml-1 mr-1"
            :style="'background-color: ' + hexColor + '; border-radius: 10px; height: 35px; width: 35px; display: inline-block'">
        </div>
<!--        <FillFieldByAiButton-->
<!--            :field-config="fieldConfig"-->
<!--            :parent-form="parentForm"-->
<!--            :hex-color="hexColor"-->
<!--            :mode="mode"-->
<!--            :read-only="readOnly"-->
<!--            :validated-field="validatedField"-->
<!--        ></FillFieldByAiButton>-->
      </template>
    </input-base>
  </div>
</template>

<script>
import ReachInput from "@/components/inputs/ReachInput";
import FormValidatedField from "@/components/forms/FormValidatedField";
import TextFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/TextFormFieldConfig";
import FormModel from "@/components/forms/FormModel";
import InputBase from "@/components/inputs/InputBase.vue";
import pantone from "@/server/com/silkplm/rpc/Pantone";
import FillFieldByAiButton from "@/components/inputs/controls/FillFieldByAiButton.vue";

export default {
  name: "PantonePreviewRenderer",
  computed: {
    pantone() {
      return pantone
    }
  },
  components: {
    FillFieldByAiButton,
    InputBase,
    ReachInput
  },

  mounted() {
    this.onChangeColor();
  },

  props: {
    validatedField: {type: FormValidatedField, required: false},
    fieldConfig: {type: TextFormFieldConfig, required: false},
    mode: {default: null},
    parentForm: {type: FormModel}
  },

  watch: {
    validatedField: function (val) {
      this.onChangeColor();
    },
    "validatedField.value": function (val) {
      this.onChangeColor();
    }
  },

  methods: {
    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },

    async onChangeColor() {
      let matches = this.validatedField.value?.match(this.regex);
      if(matches) {
        let pantoneColor = await Rpc.Pantone.pantoneByName(matches[0]);
        if (pantoneColor) {
          this.hexColor = pantoneColor.hex;
        } else {
          this.hexColor = null;
        }
      }
    }
  },

  data: () => ({
    hexColor: '',
    regex: /\b\d{2}-\d{4} TCX\b/g,
    readOnly: true
  })
}
</script>

<style scoped>

</style>